export default ['Not a chance', 'Already do this', 'I\'m down ', 'Definitely'];


// WEBPACK FOOTER //
// ./src/lib/answers.ts